import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';
import BootcampCTA from './components/BootcampCTA';

export default function RoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <div>
      <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month DevSecOps Career Roadmap`}
      subtitle="DevSecOps Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-devsecops-roadmap.pdf"
      roleKey={roleKey || ""}
    />
      <div className="mt-8">
        <BootcampCTA variant="default" context="roadmap" />
      </div>
    </div>
  );
}